<template>
  <aside class="course-lessons-list py-5">
    <h2 class="mb-5">Conteúdo programático</h2>

    <lesson-link
      v-for="lesson in lessonsWithoutModule"
      :key="'w' + lesson.id"
      :lesson="lesson"
    />

    <div v-for="module in modules" :key="'m' + module.id">
      <h6 class="mt-4 mb-3">{{ module.name }}</h6>

      <lesson-link
        v-for="lesson in module.lessons"
        :key="'l' + lesson.id"
        :lesson="lesson"
      />
    </div>
  </aside>
</template>

<script>
import get from "lodash/get";
import LessonLink from "./LessonLink";

export default {
  components: { LessonLink },
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchTerm: ""
    };
  },
  computed: {
    lessons() {
      return get(this.course, "lessons", []);
    },
    lessonsWithoutModule() {
      return this.lessons.filter(lesson => !get(lesson, "module.id"));
    },
    modules() {
      return get(this.course, "modules", [])
        .slice()
        .sort((a, b) => a.order - b.order)
        .map(module => ({
          ...module,
          lessons: this.lessons.filter(
            lesson => module.id === get(lesson, "module.id")
          )
        }));
    }
  },
  methods: {
    duration(lesson) {
      if (!lesson.duration) return "";
      let [h, m, s] = lesson.duration.split(":");
      if (h === "00") {
        return `${m}:${s}`;
      } else {
        return lesson.duration;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course-lessons-list {
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  background: black;
}
</style>
